import { render, staticRenderFns } from "./MoleculeTheHeaderLogo.vue?vue&type=template&id=0a40a87c"
import script from "./MoleculeTheHeaderLogo.vue?vue&type=script&lang=js"
export * from "./MoleculeTheHeaderLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports